import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../lib/authConfig.js';

export default function LoginPage() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((e) => console.error(e));
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-profun-midnight overflow-hidden">
      {/* Ambient gradient orbs */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-32 -right-32 h-[500px] w-[500px] rounded-full bg-profun-blue/15 blur-[100px]" />
        <div className="absolute -bottom-32 -left-32 h-[500px] w-[500px] rounded-full bg-profun-purple/12 blur-[100px]" />
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 h-[300px] w-[300px] rounded-full bg-profun-teal/8 blur-[80px]" />
      </div>

      {/* Subtle grid pattern */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      <div className="relative z-10 mx-4 w-full max-w-[380px]">
        {/* Brand */}
        <div className="mb-10 text-center">
          <div className="mb-5 flex justify-center">
            <div className="rounded-2xl bg-white/[0.07] p-4 backdrop-blur-sm ring-1 ring-white/10">
              <img src="/profun-logo.svg" alt="ProFun" className="h-14 w-14" />
            </div>
          </div>
          <h1 className="text-3xl font-bold tracking-tight text-white">KSA ProHR</h1>
          <p className="mt-2 text-sm text-white/50">
            HR management for the ProFun team
          </p>
        </div>

        {/* Sign-in card */}
        <div className="rounded-2xl border border-white/[0.08] bg-white/[0.04] p-8 backdrop-blur-md shadow-2xl">
          <button
            onClick={handleLogin}
            className="group flex w-full items-center justify-center gap-3 rounded-xl bg-white px-7 py-3.5 text-[15px] font-semibold text-profun-midnight shadow-sm transition-all duration-200 hover:shadow-lg hover:shadow-profun-blue/10 active:scale-[0.98]"
          >
            <svg className="h-5 w-5" viewBox="0 0 21 21" fill="none">
              <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
              <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
              <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
            </svg>
            Sign in with Microsoft
          </button>
          <p className="mt-5 text-center text-[11px] text-white/30">
            Secured with Microsoft Entra ID
          </p>
        </div>
      </div>
    </div>
  );
}
